import { useLanguage, t } from "./i18n";
import React, { useState, useEffect, lazy, Suspense } from 'react';
import SceneShareHome from './SceneShareHome';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import NavigationBar from './NavigationBar';
import { AuthProvider } from './VrAuthContext';
import './BlueWhiteTheme.css';
import LanguagePicker from './LanguagePicker';
import LegalPage from './LegalPage';
import LegalLinks from './LegalLinks';
import CookieBanner from './CookieBanner';
import { hasSavedSignIn } from './savedSignIn';
const MediaLibraryPage = lazy(()=>import('./MediaLibraryPage'));
const PicoLoginPage = lazy(() => import('./PicoLoginPage'));
const IOSDesignPage = lazy(() => import('./IOSDesignPage'));
const ARPage = lazy(() => import('./ARPage'));
const ModelImageGalleryPage = lazy(() => import('./ModelImageGallery'));
const ModelsPortal = lazy(() => import('./VrModelsPortal'));
const AdminPortal = lazy(() => import('./AdminPortal'));
const AuthModal = lazy(() => import('./AuthModal'));
function skipToContent(event) { event.preventDefault(); document.getElementById('main-content')?.focus(); }
function restoreLoginFocus() {
  const targets = ['#nav-login', '.mobile-menu-toggle', '.brand-link'].map(selector => document.querySelector(selector));
  targets.find(element => element?.getClientRects().length)?.focus();
}
function SiteShell() {
  const location = useLocation();
  const privateRoute = /^\/(models|admin|pico-login|media)(\/|$)/.test(location.pathname);
  const [authEnabled, setAuthEnabled] = useState(privateRoute);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  useEffect(() => { if(privateRoute) setAuthEnabled(true); }, [privateRoute]);
  useEffect(() => {
    if (authEnabled || privateRoute || /^\/(ar|ios-design)(\/|$)/.test(location.pathname)) return;
    let active = true;
    const restore = () => { hasSavedSignIn().then(saved => { if (active && saved) setAuthEnabled(true); }); };
    restore();
    window.addEventListener('focus', restore);
    window.addEventListener('storage', restore);
    return () => { active = false; window.removeEventListener('focus', restore); window.removeEventListener('storage', restore); };
  }, [authEnabled, privateRoute, location.pathname]);
  if (/^\/ios-design\/?$/.test(location.pathname)) return <div className="App public-ar-experience ios-design-experience">
    <header className="app-header"><div className="navbar"><a className="brand-link" href="/"><span className="brand-title"><img src="/scene-share-icon.png" alt="" className="portal-brand-icon" />SCENE SHARE <span>XR</span></span></a><LanguagePicker /></div></header>
    <Suspense fallback={<p>{t('Cargando…')}</p>}><IOSDesignPage /></Suspense><LegalLinks compact />
  </div>;
  if (/^\/ar(?:\/[^/]+)?\/?$/.test(location.pathname)) return <div className="App public-ar-experience">
    <a className="skip-link" href="#main-content" onClick={skipToContent}>{t('Saltar al contenido')}</a>
    <header className="app-header"><div className="navbar"><span className="brand-title">SCENE SHARE XR · AR</span><LanguagePicker /></div></header>
    <Suspense fallback={<p>{t('Cargando…')}</p>}><Routes><Route path="/ar/:token?" element={<ARPage publicAccess publicToken={location.hash?.slice(1)} />} /></Routes></Suspense>
    <LegalLinks compact />
  </div>;
  const content=<div className="App">
          <a className="skip-link" href="#main-content" onClick={skipToContent}>{t('Saltar al contenido')}</a>
          <NavigationBar onOpenAuth={() => {setAuthEnabled(true);setAuthModalOpen(true);}} />
          <Suspense fallback={<p role="status">{t('Cargando…')}</p>}><Routes>
            <Route path="/" element={<SceneShareHome />} />
            <Route path="/pico-login" element={<PicoLoginPage />} />
            <Route path="/models" element={<ModelsPortal />} />
            <Route path="/media" element={<MediaLibraryPage />} />
            <Route path="/models/:modelId/images" element={<ModelImageGalleryPage />} />
            <Route path="/models/:modelId/ar" element={<Suspense fallback={<p>{t("Cargando…")}</p>}><ARPage /></Suspense>} />
            <Route path="/admin" element={<AdminPortal />} />
            <Route path="/impressum" element={<LegalPage kind="impressum" />} />
            <Route path="/datenschutz" element={<LegalPage kind="privacy" />} />
            <Route path="/cookies" element={<LegalPage kind="storage" />} />
            <Route path="/legal" element={<LegalPage kind="impressum" />} />
            <Route path="*" element={<LegalPage kind="missing" />} />
          </Routes></Suspense>

          {authModalOpen && <Suspense fallback={<p role="status">{t('Cargando…')}</p>}><AuthModal onClose={() => { setAuthModalOpen(false); requestAnimationFrame(restoreLoginFocus); }} /></Suspense>}

          <footer className="footer-dark">
            <div>JAR AGENCY GBR • GÜSTROW</div>
            <div>{t("\xA9 2026 JAR Agency GbR. Alle Rechte vorbehalten.")}</div>
            <LegalLinks />
            <div>Copyright © {new Date().getFullYear()} Jesus Ramirez</div>
          </footer>
        </div>;
  return (authEnabled || privateRoute) ? <AuthProvider>{content}</AuthProvider> : content;
}
function App() {
  useLanguage();
  return <Router><SiteShell /><CookieBanner /></Router>;
}
export default App;
